import { Logger } from './Logger'

const eventName = 'stylesheet-loaded'
const logger = new Logger('Main Stylesheet')
let ss = null
let loaded = false
const config = { attributes: true, childList: false, subtree: false }

const callback = function (mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes') {
      loaded = true
      logger.log('loaded')
      ss.dispatchEvent(new CustomEvent(eventName))
    }
  }
}
let observer = null

const setupObserver = function () {
  if (ss === null) {
    ss = document.querySelector('#cssFile')

    if (ss) {
      if (ss.sheet != null || ss.media === 'all') {
        ss.media = 'all'
        loaded = true
      }
    }
  }

  if (ss !== null && loaded === false) {
    ss.addEventListener('load', function () {
      ss.media = 'all'
      loaded = true
      ss.dispatchEvent(new CustomEvent(eventName))
      logger.log('loaded')
    })

    if (ss.sheet != null) {
      ss.media = 'all'
      loaded = true
    }

    if (observer === null) {
      observer = new MutationObserver(callback)
    }
    observer.observe(ss, config)
  } else {
    loaded = true
  }
}

const EnsureStylesheetLoaded = function () {
  setupObserver()
  const promise = new Promise((resolve, reject) => {
    if (loaded === true) {
      resolve()
    } else {
      if (ss && ss.media === 'all') {
        loaded = true
        resolve()
      }
      if (ss) {
        ss.addEventListener(eventName, function () {
          if (observer !== null) {
            observer.disconnect()
            observer = null
          }
          resolve()
        })
      }
    }
  })

  return promise
}

export {
  EnsureStylesheetLoaded
}
